import Nullstack from 'nullstack';
export default function IconTxt({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-txt",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 8h4"
  }), "   ", Nullstack.element("path", {
    d: "M5 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M17 8h4"
  }), "   ", Nullstack.element("path", {
    d: "M19 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M10 8l4 8"
  }), "   ", Nullstack.element("path", {
    d: "M10 16l4 -8"
  }), " ");
}